import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { DEFAULT_THEME_SETTINGS, type ThemeSettings } from './theme';

/** Accept only supported preference values from the account document. */
export function parseThemePreferences(value: unknown): ThemeSettings | null {
  if (!value || typeof value !== 'object') return null;
  const input = value as Record<string, unknown>;
  if (!['light', 'dark', 'system', 'auto'].includes(String(input.mode))) return null;
  const clock = (v: unknown) => typeof v === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(v);
  return {
    mode: input.mode as ThemeSettings['mode'],
    autoStrategy: input.autoStrategy === 'fixed' ? 'fixed' : 'sun',
    darkFrom: clock(input.darkFrom) ? input.darkFrom as string : DEFAULT_THEME_SETTINGS.darkFrom,
    darkTo: clock(input.darkTo) ? input.darkTo as string : DEFAULT_THEME_SETTINGS.darkTo,
  };
}

export function subscribeThemePreferences(uid: string, receive: (value: ThemeSettings | null) => void) {
  if (!db) return () => {};
  return onSnapshot(doc(db, 'users', uid, 'private', 'settings'), (snapshot) => {
    receive(parseThemePreferences(snapshot.data()?.theme));
  }, (error: unknown) => console.warn('[theme] Account preferences unavailable', error));
}

export async function saveThemePreferences(uid: string, theme: ThemeSettings): Promise<void> {
  if (db) await setDoc(doc(db, 'users', uid, 'private', 'settings'), { theme }, { merge: true });
}
